<div>
    <datiq-table
        [tableSig]="table"
        (rowClicked)="navigateToRateviewLane($event)"
    ></datiq-table>
</div>
